import { useState, useEffect, useCallback } from "react";
import "./pageLayout.scss";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import { Card, CardContent } from "@mui/material";
import ChatIA from "../common/ChatIA/ChatIA";

const MOBILE_BREAKPOINT = 768;

const PageLayout = ({ icon: Icon, title, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  // Track viewport changes
  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false); // reset overlay state on desktop
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Close sidebar when pressing Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setSidebarOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // Prevent body scroll when mobile sidebar is open
  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isMobile, sidebarOpen]);

  const handleToggle = useCallback(() => setSidebarOpen((v) => !v), []);
  const handleClose = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="pageContainer">
      {/* Mobile backdrop */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-backdrop" onClick={handleClose} />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={handleClose} isMobile={isMobile} />

      <div className="contentContainer">
        <Navbar onMenuToggle={handleToggle} />

        <div className="mainContent">
          <Card className="mainCard">
            <div className="cardHeader">
              {Icon && <Icon className="headerIcon" />}
              <h1 className="headerTitle">{title}</h1>
            </div>
            <CardContent className="cardContent">
              {children}
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Asistente IA flotante */}
      <ChatIA />
    </div>
  );
};

export default PageLayout;
